import { useQuery } from "@tanstack/react-query";
import { publicStaffQuery } from "../api/booking.queries";

const NONE: ReadonlySet<string> = new Set();

/**
 * The services no stylist taking online bookings does (owner request 2026-10-28). Such a service has
 * no free time ever, so adding it leads a customer round the flow to an empty calendar; the menu offers
 * "Call to book" for it instead. Nothing is marked until the team has loaded, or when the salon lists
 * no stylists at all, so a slow or failed read never hides a service that can be booked.
 */
export function useUnstaffedServices(serviceIds: readonly string[]): ReadonlySet<string> {
  const { data: staff, isSuccess } = useQuery(publicStaffQuery());
  if (!isSuccess || !staff || staff.length === 0) return NONE;
  const done = new Set(staff.flatMap((person) => person.serviceIds));
  return new Set(serviceIds.filter((id) => !done.has(id)));
}
